import { render } from "./PolicyShoppingView.vue?vue&type=template&id=6c939f6d&scoped=true"
const script = {}

import "./PolicyShoppingView.vue?vue&type=style&index=0&id=6c939f6d&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c939f6d"]])

export default __exports__